<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-text>
        <div class="pt-6">
          <h1 class="pb-8" v-text="$t('logout')" />
          <div>
            <h3 class="pb-2" v-text="$t('leave_remark')" />
            <!--  :value="note" ? -->
            <KtznAdminTextArea v-model="note" :rows="5" @input="updateNote" />
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pb-6 me-2">
        <v-spacer />
        <KtznAdminButton :isOutlined="true" :label="$t('cancel')" @onClick="dialog = false" />
        <KtznAdminButton :label="$t('logout')" @onClick="$emit('logOut', note)" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { computed, createComponent, PropType, value, Wrapper } from "vue-function-api";
import store from "@/store";
import KtznAdminButton from "@/framework/components/common/KtznAdminButton.vue";
import KtznAdminTextArea from "@/framework/components/common/KtznAdminTextArea.vue";

export default createComponent({
  name: "SandboxLogoutDialog",
  props: ["dialogProp"] as any as PropType<{
    dialogProp: boolean;
  }>,
  components: {
    KtznAdminButton,
    KtznAdminTextArea,
  },
  setup(props, context) {
    const note: Wrapper<string> = value(store.getters.getMemo ? store.getters.getMemo : "");

    //Computed Properties
    const dialogState: Wrapper<boolean> = computed(
      () => props.dialogProp,
      (val) => context.emit("dialogState", val)
    );
    const dialog: Wrapper<boolean> = computed(
      () => dialogState.value,
      (val) => (dialogState.value = val)
    );

    const updateNote = (val: string) => (note.value = val);

    return {
      note,
      dialog,
      dialogState,
      updateNote,
    };
  },
});
</script>

<style scoped>
.v-card__text {
  color: #000000de !important;
}
</style>
